'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _draftJs = require('draft-js');

exports.default = function (editorState, block) {
  var blockKey = block.getKey();
  var depth = block.getDepth();
  var contentState = editorState.getCurrentContent();
  var blockMap = contentState.getBlockMap();

  var newBlock = block.set('depth', depth - 1);
  var newBlockMap = blockMap.set(blockKey, newBlock);

  return _draftJs.EditorState.push(editorState, contentState.merge({ blockMap: newBlockMap }), 'adjust-depth');
};


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src023959432/src/github.com/GipsyBot/gipsy-webapp/node_modules/draft-js-list-depth-plugin/lib/utils/decreaseBlockDepth.js
// module id = 966
// module chunks = 0